import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

export default {
  getInvoices(endpoint, cb) {
    axios
      .get(endpoint)
      .then(({ data }) => {
        cb(data);
      })
      .catch(handleAxiosError);
  },

  getInvoiceDetail(endpoint, cb) {
    axios
      .get(endpoint)
      .then(({ data }) => {
        cb(data.data);
      })
      .catch(handleAxiosError);
  },
};
